<template>
  <!-- Leaf: a plain link. -->
  <RouterLink v-if="!hasChildren" :to="item.url || '/'" class="dk-mnav__link" @click="emit('navigate')">
    {{ item.label }}
  </RouterLink>

  <!-- Branch: a native <details> accordion — zero JS, accessible, keyboard-friendly. -->
  <details v-else class="dk-mnav__group">
    <summary class="dk-mnav__summary">
      <span>{{ item.label }}</span>
      <span class="dk-mnav__caret" aria-hidden="true">▾</span>
    </summary>
    <div class="dk-mnav__children">
      <RouterLink v-if="item.url" :to="item.url" class="dk-mnav__link dk-mnav__link--all" @click="emit('navigate')">
        View all
      </RouterLink>
      <MobileNavItem v-for="(child, i) in item.children" :key="i" :item="child" @navigate="emit('navigate')" />
    </div>
  </details>
</template>

<script setup lang="ts">
import { computed } from "vue"
import type { MenuItem } from "../stores/bootstrap"

// Self-referential (recursive) component — resolves by filename in Vue SFCs.
defineOptions({ name: "MobileNavItem" })

const props = defineProps<{ item: MenuItem }>()
const emit = defineEmits<{ navigate: [] }>()

const hasChildren = computed(() => !!props.item.children && props.item.children.length > 0)
</script>
